import { Button, Paper } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Action, Dispatch } from 'redux';

import { Table, TableBody, TableCell, TableHead, TableRow } from '../../components/Table';
import TablePagination, { IPageEvent } from '../../components/TablePagination/TablePagination';
import withDialog, { IDialogProps } from '../../hoc/Dialog';
import { IPaginationMetaResponse, IPaginationParams } from '../../libs/quickjobs-api';
import {
  fetchReviewsRequest,
  IReviewRemoveRequestAction,
  IReviewsFetchRequestAction,
  removeReviewRequest,
} from '../../store/actions/reviews';
import { IReview, IReviewsState } from '../../store/types/review';

import styles from './styles';

class ReviewSummary extends React.Component<IProps & IDialogProps, IState> {
  private static readonly DEFAULT_LIMIT = 10;

  public state = {
    detailId: null,
    searchingText: '',
    limit: ReviewSummary.DEFAULT_LIMIT,
  };

  public componentDidMount() {
    this.props.fetchReviews({ limit: this.state.limit });
  }

  public removeReview(id: number) {
    return () => {
      this.props.openDialog(
        `Remove the Review ${id}`,
        'Are you sure you want to perform this action?',
        () => {
          this.props.removeReview(
            id
            // this.props.fetchReviews({ limit: ReviewSummary.DEFAULT_LIMIT })
          );
        }
      );
    };
  }

  public handlePagination() {
    return (event: IPageEvent, limit: number) => {
      this.setState({ limit });
      switch (event) {
        case IPageEvent.FIRST_PAGE:
          this.props.fetchReviews({
            limit: limit,
          });
          break;
        case IPageEvent.BACK:
          const firstJob: IReview = this.props.reviews[0];
          this.props.fetchReviews({
            since: firstJob.created_at,
            limit: limit,
          });
          break;
        case IPageEvent.NEXT:
          const lastJob: IReview = this.props.reviews[this.props.reviews.length - 1];
          this.props.fetchReviews({
            until: lastJob.created_at,
            limit: limit,
          });
          break;
      }
    };
  }

  public render() {
    const rows = this.props.reviews as IReview[];
    const meta = this.props.meta;

    if (!rows.length) {
      return <p>No data!</p>;
    }

    return (
      <>
        <Paper className={this.props.classes.root}>
          {rows.length ? (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell numeric={true}>ID</TableCell>
                  <TableCell>Job</TableCell>
                  <TableCell>Author</TableCell>
                  <TableCell>Target User</TableCell>
                  <TableCell numeric={true}>Rating</TableCell>
                  <TableCell>Message</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map(r => {
                  return (
                    <TableRow key={r.id} hover={true}>
                      <TableCell numeric={true}>{r.id}</TableCell>
                      <TableCell>{r.job ? r.job.id : r.job_id}</TableCell>
                      <TableCell>
                        {r.author ? `${r.author.given_name} ${r.author.family_name}` : r.author_id}
                      </TableCell>
                      <TableCell>
                        {r.subject_user
                          ? `${r.subject_user.given_name} ${r.subject_user.family_name}`
                          : r.subject_user_id}
                      </TableCell>
                      <TableCell numeric={true}>{r.rating}</TableCell>
                      <TableCell>{r.message}</TableCell>
                      <TableCell>
                        <Button variant="contained" onClick={this.removeReview(r.id)}>
                          Remove
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          ) : null}
          {meta ? (
            <TablePagination
              hasPreviousPage={meta.has_previous}
              hasNextPage={meta.has_next}
              onChangePage={this.handlePagination()}
              defaultLimit={this.state.limit}
            />
          ) : null}
        </Paper>
      </>
    );
  }
}

interface IProps {
  reviews: IReview[];
  meta: IPaginationMetaResponse;

  fetchReviews: (params?: IPaginationParams) => IReviewsFetchRequestAction;
  removeReview: (id: number, onSuccess?: () => Action) => IReviewRemoveRequestAction;

  classes: { [name: string]: string };
}

interface IState {
  limit: number;
}

const mapStateToProps = (state: { reviews: IReviewsState }) => {
  return {
    reviews: state.reviews.reviews,
    meta: state.reviews.meta,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    fetchReviews: () => dispatch(fetchReviewsRequest()),
    removeReview: (id: number, onSuccess?: () => Action) =>
      dispatch(removeReviewRequest(id, onSuccess)),
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withStyles(styles),
  withDialog
)(ReviewSummary);



// WEBPACK FOOTER //
// ./src/screens/Reviews/Reviews.tsx